"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asisSubAppLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = __importStar(require("react-dom"));
const features_1 = require("../../features");
// providers
const translations_1 = require("../../translations");
const featureFlag_1 = require("../../featureFlag");
const eventBus_1 = require("../../eventBus");
const providers_1 = require("./providers");
const initializer_1 = require("../../initializer");
const initializer_2 = require("../../initializer");
const tracker_1 = require("../../tracker");
/**
 * Builds the subapp config object and injects it
 * into window.globals so it can be shared with frame
 *
 * The rendering of the subapp in the DOM is delegated
 * to the DynamicLoader
 */
const asisSubAppLoader = async ({ id, API, app: App, translationsConfig, trackerConfig, featureFlagConfig, }) => {
    const AppWithProviders = ({ history }) => ((0, jsx_runtime_1.jsx)(providers_1.SubAppProviders, { history: history, children: (0, jsx_runtime_1.jsx)(App, {}) }));
    const config = {
        verticalId: id,
        entrypoint: async (domElement, _store, _history, _initializedFeatures, _externalComponents, data) => {
            initializer_1.AsisSession.finishSession();
            initializer_1.AsisSession.initSession(data.sessionData);
            (0, eventBus_1.setGlobalEventBus)(data.eventBus);
            trackerConfig && (await (0, tracker_1.initAllTrackers)(trackerConfig, API, initializer_2.GenericUSDManager, initializer_2.Authenticator));
            try {
                if (featureFlagConfig) {
                    await (featureFlagConfig.isRequiredPublicFF
                        ? (0, featureFlag_1.initFeatureFlagPublic)(featureFlagConfig, API)
                        : (0, featureFlag_1.initFeatureFlag)(featureFlagConfig, API));
                }
            }
            catch {
                features_1.Log.error('Can`t initiate translations. Check network');
            }
            try {
                if (translationsConfig) {
                    await (0, translations_1.initConfigWebAndOwnTranslations)(API, translationsConfig);
                }
            }
            catch {
                features_1.Log.error('Can`t initiate translations . Check network');
            }
            ReactDOM.render((0, jsx_runtime_1.jsx)(AppWithProviders, { history: data.history || _history }), domElement);
        },
        reducers: {},
        wrapupConfig: {},
    };
    window.globals = window.globals || {};
    window.globals[id] = config;
    window.globalPromises?.[id]?.();
};
exports.asisSubAppLoader = asisSubAppLoader;
//# sourceMappingURL=index.js.map